import { createContextAwareHook } from './useContextAwareHook';
import {
  useGetStorageQuery,
  usePublicGetStorageQuery,
  useGetStorageEntriesQuery,
  usePublicGetStorageEntriesQuery,
  useGetStorageEntriesDefaultsQuery,
  usePublicGetStorageEntriesDefaultsQuery,
  useUpdateStoragesMutation,
  useCreateStorageEntryMutation,
  useUpdateStorageEntryMutation,
  useDeleteStorageEntryMutation
} from '../features/modules/storageApiSlice';

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting storage data based on the current route.
 */
export const useContextAwareGetStorage = createContextAwareHook(
  useGetStorageQuery,
  usePublicGetStorageQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting storage entries based on the current route.
 */
export const useContextAwareGetStorageEntries = createContextAwareHook(
  useGetStorageEntriesQuery,
  usePublicGetStorageEntriesQuery
);

/**
 * Returns a hook that automatically selects between public and private APIs
 * for getting storage entries defaults based on the current route.
 */
export const useContextAwareGetStorageEntriesDefaults = createContextAwareHook(
  useGetStorageEntriesDefaultsQuery,
  usePublicGetStorageEntriesDefaultsQuery
);

// Export mutation hooks directly
export {
  useUpdateStoragesMutation,
  useCreateStorageEntryMutation,
  useUpdateStorageEntryMutation,
  useDeleteStorageEntryMutation
}; 